import {
  TemplateState,
  RawTemplate,
  TemplateSection,
  TemplateInput
} from "./types";
import { createModule } from "direct-vuex";
import { moduleActionContext } from "..";
import { InputDependency, TemplateResource } from "./types";
import actions from "./actions";

const template = createModule({
  namespaced: true,
  state: (): TemplateState => {
    return {
      templates: {},
      templatesList: [],
      selected: {
        name: "",
        description: "",
        sections: []
      },
      activeSection: -1
    };
  },
  getters: {
    usedVariables(state) {
      let vars: string[] = [];
      state.selected.sections.forEach(section => {
        section.inputs.forEach(input => {
          vars.push(input.name.toLowerCase());
        });
      });
      return vars;
    },
    templates(state) {
      return state.templatesList.map(id => {
        return state.templates[id];
      });
    }
  },
  mutations: {
    UPDATE_SELECTED(state, attrs: Partial<RawTemplate>) {
      state.selected = { ...state.selected, ...attrs };
    },
    CLEAR_SELECTED(state) {
      state.selected = {
        name: "",
        description: "",
        sections: []
      };
    },
    ADD_SECTION_TO_SELECTED(state, section: TemplateSection) {
      state.selected.sections.push(section);
      state.activeSection = state.selected.sections.length - 1;
    },
    SWAP_SECTION_DOWN(state, index: number) {
      if (state.selected.sections.length > index + 1) {
        state.selected.sections[index] = state.selected.sections.splice(
          index + 1,
          1,
          state.selected.sections[index]
        )[0];
      }
    },
    SWAP_SECTION_UP(state, index: number) {
      if (index - 1 >= 0) {
        state.selected.sections[index] = state.selected.sections.splice(
          index - 1,
          1,
          state.selected.sections[index]
        )[0];
      }
    },
    REMOVE_SECTION_FROM_SELECTED(state, index: number) {
      state.selected.sections.splice(index, 1);
    },
    ADD_INPUT_TO_SECTION(
      state,
      attrs: { input: TemplateInput; section: number }
    ) {
      state.selected.sections[attrs.section].inputs.push(attrs.input);
    },
    UPDATE_INPUT_FROM_SECTION(
      state,
      attrs: { input: TemplateInput; inputIndex: number; section: number }
    ) {
      state.selected.sections[attrs.section].inputs.splice(
        attrs.inputIndex,
        1,
        attrs.input
      );
    },
    REMOVE_INPUT_FROM_SECTION(
      state,
      attrs: { inputIndex: number; section: number }
    ) {
      state.selected.sections[attrs.section].inputs.splice(attrs.inputIndex, 1);
    },
    ADD_DEPENDENCY_TO_INPUT(
      state,
      attrs: {
        dependency: InputDependency;
        sectionIndex: number;
        inputIndex: number;
      }
    ) {
      state.selected.sections[attrs.sectionIndex].inputs[
        attrs.inputIndex
      ].depends_on.push(attrs.dependency);
    },
    REMOVE_DEPENDENCY_FROM_INPUT(
      state,
      attrs: {
        dependencyIndex: number;
        sectionIndex: number;
        inputIndex: number;
      }
    ) {
      state.selected.sections[attrs.sectionIndex].inputs[
        attrs.inputIndex
      ].depends_on.splice(attrs.dependencyIndex, 1);
    },
    SET_ACTIVE_SECTION(state, val: number) {
      state.activeSection = val;
    },
    SET_TEMPLATES(state, templates: TemplateResource[]) {
      state.templates = {};
      state.templatesList = [];

      templates.forEach(template => {
        state.templates[template.id] = template;
        state.templatesList.push(template.id);
      });
    },
    REMOVE_TEMPLATE(state, id: string) {
      let idx = state.templatesList.findIndex(b => {
        return b == id;
      });
      state.templatesList.splice(idx, 1);
      delete state.templates[id];
    }
  },
  actions: actions
});

export default template;
export const templateActionContext = (context: any) =>
  moduleActionContext(context, template);
